<template>
	<div>
		<div class="lmy-mask-s lmy-mask-s-hack" @click="cancel"></div>
	    <!--酒店列表-排序-->
	    <transition  name="slideinup" >
		    
		    <div class="lmy-filter-select lmy-filter-recommend" v-show="data.showRecommend">
			        <ul class="filter-list">
						<li v-for="item in sortList" :key="item.id" :class="SortTypes==item.id?'active':''" @click="selectSortTypes(item.id,item.name)">{{item.name}}</li>
			        </ul>
		    </div>
		</transition>
		<transition  name="slideinup" >
		    <!--酒店列表-位置距离-->
		    <div class="lmy-filter-select lmy-filter-address" v-show="data.showAddress">
		    	    <div class="infinite-loading-containers" v-if="!LandmarkGroups">
                        <i class="loading-defaults"></i>
                    </div>
			        <div class="filter-content">
			            <div class="left" >
			                <ul class="address-menu">
												<!-- v-if="(lmName!='行政区'&&index!=0)||((lmiName!='行政区'&&index!=0)||(flag&&lmiName&&index!=0))" -->
			                    <li :class="item.active?'active point':''" v-for="(item,index) in LandmarkGroups" @click="setGroupName(item)" v-if="!((index==0&&lmName=='行政区')||(index==0&&lmiGruopName=='行政区')||(index==0&&!flag&&!lmiName))">
			                    	<span class="lmy-sort-active-point" v-show="(lmiRadius&&index==0)||(lmiGruopName==item.GroupName)">.</span>
			                    	{{item.GroupName}}
			                	</li>               
							</ul>
			            </div>
			            <div class="right">
			                <ul class="filter-list">
			                    <li :class="lmiName==item.Name||lmiRadius==item.value?'active':''" v-for="item in tagList.Landmarks" @click="setLandmark(item,tagList.GroupName)">
			                    	{{item.Name}}
			                    	<i class="icon iconfont icon-fuxuankuang" v-if="lmiName==item.Name||lmiRadius==item.value"></i>
			                    </li>
			                
			                </ul>
			            </div>
			        </div>
			
			        <div class="filter-footer">
			            <div class="reset" @click="resetLM">重置</div>
			            <div class="finish" @click="cancel">完成</div>
			        </div>
		    </div>
		</transition>
		<transition  name="slideinup" >
		    <!--酒店列表-价格星级-->
		    <div class="lmy-filter-select lmy-filter-star" v-show="data.showStar">
			        <div class="filter-title" v-show="data.from==1">价格</div>
			        <ul class="filter-select-content" v-show="data.from==1">
			            <li :class="priceName=='¥150以下'?'item active':'item'"  @click="selectPrice('',150,'¥150以下',1)">    <div>¥150以下</div></li>
			            <li :class="priceName=='¥150-300'?'item active':'item'"  @click="selectPrice(150,300,'¥150-300',2)">  <div>¥150-300</div></li>
			            <li :class="priceName=='¥300-600'?'item active':'item'"  @click="selectPrice(300,600,'¥300-600',3)">  <div>¥300-600</div></li>
			            <li :class="priceName=='¥600-1000'?'item active':'item'"  @click="selectPrice(600,1000,'¥600-1000',4)"><div>¥600-1000</div></li>
			            <li :class="priceName=='¥1000以上'?'item active':'item'"  @click="selectPrice(1000,'','¥1000以上',5)">  <div>¥1000以上</div></li>
			        </ul>
			        <div class="filter-title">星级</div>
			        <ul class="filter-select-content star-select-content">
			            <li :class="starName=='二星/经济'?'item active':'item'" @click="selectStar(1,'二星/经济')"><div>二星/经济</div></li>
			            <li :class="starName=='三星/舒适'?'item active':'item'" @click="selectStar(2,'三星/舒适')"><div>三星/舒适</div></li>
			            <li :class="starName=='四星/高档'?'item active':'item'" @click="selectStar(3,'四星/高档')"><div>四星/高档</div></li>
			            <li :class="starName=='五星/豪华'?'item active':'item'" @click="selectStar(4,'五星/豪华')"><div>五星/豪华</div></li>
			        </ul>
					<div class="filter-footer">
			            <div class="reset" @click="resetPS">重置</div>
			            <div class="finish" @click="cancel">完成</div>
			        </div>
		    </div>
			
		</transition>

	</div>
</template>
<script>
export default {
  name: "hotelSort",
  props: ["Radius", "hotelSortData"],
  // props:{
  // 	Radius:{
  // 		type:Number,
  // 	},
  // 	hotelSortData:{
  // 		type:Object,
  // 		default:()=>{
  // 			return {}
  // 		}
  // 	}
  // },
  data() {
    return {
      data: {},
      SortTypes: 3,
      priceName: 0,
      lmName: "",
      lmiRadius: this.Radius ? this.Radius : "",
      tagList: "",
      lmiTarget: "",
      starValue: "",
      starName: "",
      lmiName: "",
      lmiGruopName: "",
      LandmarkGroups: "",
      sortList: [
        { id: 0, name: "推荐排序" },
        { id: 1, name: "低价优先" },
        { id: 4, name: "好评优先" },
        { id: 3, name: "距离 近 → 远" }
      ],
			flag:false
    };
  },
  watch: {
    hoteSortData(val) {
      this.data = val;
    }
  },
  methods: {
    selectSortTypes(val, name) {
      this.SortTypes = val;
      this.$emit("selectSortTypes", val, name);
    },
    selectStar(star, name) {
      if (this.starName == name) {
        this.starName = "";
        this.starValue = "";
      } else {
        this.starName = name;
        this.starValue = star;
      }
    },
    selectPrice(min, max, name, pn) {
      if (this.priceName == name) {
        this.priceName = "";
        this.priceMin = "";
        this.priceMax = "";
      } else {
        this.priceName = name;
        this.priceMin = min;
        
        this.priceMax = max;
      }
    },
    setLandmark(lm, gruopName) {
      if (!lm.ID) {
        this.lmiRadius = lm.value;
      } else {
        if (gruopName != "行政区") {
          this.lmiRadius = 4;
        }
        this.lmiName = lm.Name;
        this.lmiTarget = lm;
        this.lmiGruopName = gruopName;
      }

      return;

      // this.$emit('selectLandmark',lm)
    },
    setGroupName(item) {
      this.$nextTick(function() {
        for (var i = 0; i < this.LandmarkGroups.length; i++) {
          this.LandmarkGroups[i].active = false;
        }
        this.$set(item, "active", item.active ? false : true);
        this.lmName = item.GroupName;
        // this.tagList=item.Landmarks;
        this.tagList = item;
        if (this.lmName == "行政区") {
          this.lmiRadius = "";
        }
      });
    },
    cancel() {
      if (this.data.showRecommend) {
        this.sortList.forEach(item => {
          if (item.id == this.SortTypes) {
            this.$emit("selectSortTypes", item.id, item.name);
            return;
          }
        });
      }
      if (this.data.showAddress) {
        if (this.lmiTarget.ID) {
          this.SortTypes = 3;
        }
        this.$emit(
          "selectLandmark",
          this.lmiTarget,
          this.lmiRadius,
          this.SortTypes
        );
      }
      if (this.data.showStar) {
        this.$emit("selectStar", this.starValue, this.starName);
        this.$emit("selectPrice", this.priceMin, this.priceMax, this.priceName);
      }
    },
    resetLM() {
      for (var i = 0; i < this.LandmarkGroups.length; i++) {
        this.LandmarkGroups[i].active = false;
      }
      this.lmiTarget = "";
      this.lmiRadius = "";
      this.lmiName = "";
      this.lmiGruopName = "";
      this.SortTypes = 3;
			if(this.flag){
				this.tagList = this.LandmarkGroups[0];
      	// this.lmName = this.LandmarkGroups[0].GroupName;
			}else{
				this.tagList = this.LandmarkGroups[1];
      	// this.lmName = this.LandmarkGroups[1].GroupName;
			}
    },
    resetPS() {
      this.starValue = "";
      this.starName = "";
      this.priceName = "";
      this.priceMin = "";
      this.priceMax = "";
    },
    getLandmarkGroups() {
      var that = this;
      var params = {
        isCN: that.data.from == 1 ? true : false,
        pid: that.data.RegionID,
        q: "",
        group: "",
        pageSize: 13
      };
      that
        .getRequest({
          url: that.Api.getLandmarkGroups,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.LandmarkGroups = res.Result;
            that.initLMList();
          }
        });
    },
    //插入距离我位置到所有坐标中
    initLMList() {
			if(this.data.RegionID == this.data.MyCityRegionID){
				this.flag = true
			}
      if (this.data.from == 1) {
        var distance = {
					GroupName:"距离",
          // GroupName:
          //   this.data.RegionID == this.data.MyCityRegionID
          //     ? "距离"
          //     : "距离市中心",
          active: true,
          Landmarks: [
            { value: "", Name: "不限" },
            { value: 0.5, Name: "500米内" },
            { value: 1, Name: "1公里内" },
            { value: 2, Name: "2公里内" },
            { value: 4, Name: "4公里内" },
            { value: 8, Name: "8公里内" },
            { value: 10, Name: "10公里内" }
          ]
        };

        //插入距离我位置的
        this.LandmarkGroups.unshift(distance);
      }

      this.lmiName = this.data.lmiName;
      this.priceName = this.data.priceName;
      this.starName = this.data.starName;
			// this.lmName = this.LandmarkGroups[0].GroupName;
			if(this.flag){
				this.tagList = this.LandmarkGroups[0];
      	// this.lmName = this.LandmarkGroups[0].GroupName;
			}else{
				this.tagList = this.LandmarkGroups[1];
      	// this.lmName = this.LandmarkGroups[1].GroupName;
			}

      if (this.lmiName) {
        this.lmiRadius = 4;
        this.lmiGruopName = this.data.lmiGruopName;
        // this.LandmarkGroups[0].Landmarks[]
      }
    }
  },
  mounted() {
    this.data = this.hotelSortData;
    this.getLandmarkGroups();
  },
  activated() {
    if (this.LandmarkGroups) {
      this.$nextTick(function() {
        this.getLandmarkGroups();
        this.lmiName = this.hotelSortData.lmiName;
        this.lmiGruopName = this.hotelSortData.lmiGruopName;
        this.lmiTarget = this.hotelSortData.lmiTarget;

        //lmiGruopName 当选择了行政区后，就不显示距市中心距离
        if (this.lmiGruopName && this.lmiGruopName != "行政区") {
          this.lmiRadius = 4;
          this.SortTypes = 3;
          // this.LandmarkGroups[0].Landmarks[]
        } else {
          // this.SortTypes=0;
          this.lmiRadius = "";
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/hotelSort.vue